export default __webpack_public_path__ + "static/media/Believer's Leggings of the Aureate.1ea75e27.jpg";